import { useQuery } from '@tanstack/react-query'

import { useAuth } from '../auth/auth.context'
import { chatService } from '../services/chat.service'

const CHAT_UNREAD_POLL_MS = 3_000

export function useChatUnread() {
  const { user, isLoading } = useAuth()
  const isAuthenticated = Boolean(user)

  return useQuery({
    queryKey: ['chat-unread-count'],
    queryFn: () => chatService.getUnreadCount(),
    enabled: isAuthenticated && !isLoading,
    retry: false,
    refetchInterval: isAuthenticated ? CHAT_UNREAD_POLL_MS : false,
    refetchIntervalInBackground: false,
  })
}
